import React, { memo } from "react";
import Sidebar from "./Sidebar";
import SidebarItems from "./SidebarItems";
import SidebarSection from "./SidebarSection";
const GlobalSidebar = ({ currentServiceId, customMenuForCurrentService, footerMenu, services, showCollapseButton, sx, linkComponent, }) => (React.createElement(Sidebar, { sx: sx, showCollapseButton: showCollapseButton },
    React.createElement(SidebarSection, null,
        React.createElement(SidebarItems, { linkComponent: linkComponent, services: services, currentServiceId: currentServiceId, customMenuForCurrentService: customMenuForCurrentService })),
    footerMenu && React.createElement(SidebarSection, null, footerMenu)));
export default memo(GlobalSidebar);
//# sourceMappingURL=GlobalSidebar.js.map